import VIEW_MODES from '../../../../../../../core/enums/view-modes.types';
import AqlQueryModel from '../../../../../../../core/models/distribution/AqlQueryModel';
import ViewHelpers from '../../../../../../../core/utils/view.helpers';
import DistributionBundlesDAO from '../../../../../DAO/bundles/DistributionBundlesDAO';
import AqlQueryCreateEditService from '../../../create/aqlQueryCreateEditService/aql.query.create.edit.service';

export default class BundleSpecComponent {
	constructor() {
		this.template = require('./bundle.spec.view.html');
		this.controller = BundleSpecController;
		this.bindings = {
			bundleSpecModel: '<'
		};
	}
}

BundleSpecComponent.META = {
	name: 'bundleSpec'
};

class BundleSpecController {

	constructor($stateParams, $scope, aqlQueryCreateEditService, distributionBundleDAO, JFrogTableViewOptions) {
		this.$stateParams = $stateParams;
		this.$scope = $scope;
		this.aqlQueryCreateEditService = aqlQueryCreateEditService;
		this.distributionBundleResource = distributionBundleDAO.Resource;
		this.VIEW_MODES = VIEW_MODES;
		this.infoOptions = ['Queries', 'Original Request'];
		this.selectedInfoOption = this.infoOptions[0];
		this.viewHelpers = ViewHelpers;
		this.JFrogTableViewOptions = JFrogTableViewOptions;
	}

	$onInit() {
		this.recipeJson = JSON.stringify(this.bundleSpecModel, null, '\t');
		this.bundleSpecModel.queries.forEach((query) => {
			query.model = new AqlQueryModel(query);
		});

		this.setTablesColumns();
	}

	getDisplayQuery(aql) {
		return ViewHelpers.beautifyAQL(aql);
	}

	setTablesColumns() {
		this.buildsTableColumns = [{
			field: 'name',
			header: 'Bulid Name',
			width: '50%',
			cellTemplate: `<div ng-bind="row.entity.name"></div>`
		}, {
			field: 'number',
			header: 'Build Number',
			width: '50%',
			cellTemplate: `<div ng-bind="row.entity.number"></div>`
		}];
		this.propertiesTableColumns = [{
			field: 'key',
			header: 'Key',
			width: '50%',
			cellTemplate: `<div ng-bind="row.entity.key"></div>`
		}, {
			field: 'value',
			header: 'Value',
			width: '50%',
			cellTemplate: `<div ng-bind="row.entity.value"></div>`
		}];
		this.mappingsTableColumns = [{
			field: 'input',
			header: 'Input',
			width: '50%',
			cellTemplate: `<div ng-bind="row.entity.input"></div>`
		}, {
			field: 'output',
			header: 'Output',
			width: '50%',
			cellTemplate: `<div ng-bind="row.entity.output"></div>`
		}];
		this.addedPropsTableColumns = [{
			field: 'key',
			header: 'Key',
			width: '50%',
			cellTemplate: `<div ng-bind="row.entity.key"></div>`
		}, {
			field: 'values',
			header: 'Values',
			width: '50%',
			cellTemplate: `<div ng-bind="appScope.$ctrl.viewHelpers.stringifyData(row.entity.values)"></div>`
		}];
	}
}

BundleSpecController.$inject = [
	'$stateParams',
	'$scope',
	AqlQueryCreateEditService.META.name,
	DistributionBundlesDAO.META.name,
	'JFrogTableViewOptions'
];




// WEBPACK FOOTER //
// ./modules/distribution/modules/distribution/components/bundle/version/components/bundleSpec/bundle.spec.component.js